module.exports = __webpack_public_path__ + "static/media/icone-menu-ia.c2aa5aee.svg";